import React, { useEffect } from 'react';
import { STEP_LINK_BANK, STEP_MANUAL } from '../../../AddBank/AddBank';
import Template from '../../Template/Template';
import BankCautionIcon from 'src/assets/images/bank_caution-icon.svg';
import { MANUAL } from '../../../../../settings/settings';
import { dispatchPageLoad } from '../../../../../redux/utils/analytics-helper';

const Generic = ({
  setBankProgress,
  isSalesforceRep,
  plaidAttempts,
  everifyAttempts,
  path,
}) => {
  useEffect(() => {
    dispatchPageLoad(`VerificationFail${path === MANUAL ? 'Manual' : 'Plaid'}`);
  }, [path]);

  return (
    <div>
      {!isSalesforceRep && plaidAttempts <= 2 && everifyAttempts <= 2 && (
        <Template
          image={BankCautionIcon}
          header={`We are unable to verify your bank.`}
          msg={
            <div>
              Some of the information you entered does not match what we have on
              file.
              <br></br>
              <br></br>
              Please ensure your information is consistent, then try again.
            </div>
          }
          nextButton={`Enter Manually`}
          onNextClick={() => setBankProgress(STEP_MANUAL)}
          textOffRamp={'Choose another bank'}
          nextDestination={() => setBankProgress(STEP_LINK_BANK)}
        />
      )}
      {!isSalesforceRep && plaidAttempts > 2 && everifyAttempts <= 2 && (
        <Template
          image={BankCautionIcon}
          header={`We are unable to verify your bank.`}
          msg={
            <div>
              Some of the information you entered does not match what we have on
              file.
              <br></br>
              <br></br>
              Please ensure your information is consistent, then try again.
            </div>
          }
          nextButton={`Enter Manually`}
          onNextClick={() => setBankProgress(STEP_MANUAL)}
        />
      )}
      {!isSalesforceRep && plaidAttempts <= 2 && everifyAttempts > 2 && (
        <Template
          image={BankCautionIcon}
          header={`We are unable to verify your bank.`}
          msg={
            <div>
              Some of the information you entered does not match what we have on
              file.
              <br></br>
              <br></br>
              Please ensure your information is consistent, then try again.
            </div>
          }
          nextButton={`Choose another bank`}
          onNextClick={() => setBankProgress(STEP_LINK_BANK)}
        />
      )}
      {isSalesforceRep && (
        <Template
          image={BankCautionIcon}
          header={`We are unable to verify your bank.`}
          msg={
            <div>
              Some of the information you entered does not match what we have on
              file.
              <br></br>
              <br></br>
              Please ensure your information is consistent, then try again.
            </div>
          }
          nextButton={`Enter Manually`}
          onNextClick={() => setBankProgress(STEP_MANUAL)}
        />
      )}
    </div>
  );
};

export default Generic;
